import { Spin } from 'antd';
import { ImportRecord } from '../../../../types/Import';
import { ImportPreviousImportRow } from './ImportPreviousImportRow';

interface ImportPreviousImportsProps {
  imports: ImportRecord[] | undefined;
  isLoading: boolean;
  isError: boolean;
  onProceedToMapping: (importId: number) => void;
  onDelete: (importRecord: ImportRecord) => void;
  onRetry: () => void;
}

export const ImportPreviousImports = ({
  imports,
  isLoading,
  isError,
  onProceedToMapping,
  onDelete,
  onRetry,
}: ImportPreviousImportsProps) => {
  if (isLoading) {
    return (
      <div className="mt-4">
        <div className="text-brand-grey-dark text-sm font-semibold mb-2">Previous Imports</div>
        <div className="flex flex-col gap-1">
          {[1, 2].map((i) => (
            <div key={i} className="h-[52px] bg-neutral-100 rounded-lg animate-pulse" />
          ))}
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="mt-4">
        <div className="text-brand-grey-dark text-sm font-semibold mb-2">Previous Imports</div>
        <div className="flex items-center justify-between py-3 px-3 bg-neutral-100 rounded-lg">
          <span className="text-neutral-700 text-sm">Failed to load imports</span>
          <button
            className="text-sm text-taskonioGreen-600 hover:underline cursor-pointer bg-transparent border-none"
            onClick={onRetry}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!imports || imports.length === 0) {
    return null;
  }

  return (
    <div className="mt-4">
      <div className="text-brand-grey-dark text-sm font-semibold mb-2">Previous Imports</div>
      <div className="flex flex-col gap-0.5 max-h-[260px] overflow-y-auto">
        {imports.map((importRecord) => (
          <ImportPreviousImportRow
            key={importRecord.id}
            importRecord={importRecord}
            onProceedToMapping={onProceedToMapping}
            onDelete={onDelete}
          />
        ))}
      </div>
    </div>
  );
};
